import React, { useEffect } from 'react';
import splashGif from '../../assets/Kondify Splash GIF.gif';

const VideoSplash = ({ onComplete }) => {
    useEffect(() => {
        // Since GIFs don't have an 'onEnded' event, 
        // we use a timeout that matches the animation duration.
        // Adjust the time (ms) to match your GIF's length.
        const timer = setTimeout(() => {
            onComplete();
        }, 3000); // 3 seconds fallback

        return () => clearTimeout(timer);
    }, [onComplete]);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: '#000000', // matches the GIF background
            zIndex: 999999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
        }}>
            <img
                src={splashGif}
                alt="Kondify Loading..."
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                }}
            />
        </div>
    );
};

export default VideoSplash;
